import request from "@/utils/request";
// 获取初始化信息
export function getConfig() {
  return request({
    method: "GET",
    url: "bootstrap/config"
  });
}

// 获取圈子列表
export function getTopicsDataApi(topic_id) {
  return request({
    method: "GET",
    url: `topics/${topic_id}`
  });
}

// 获取圈子页帖子列表
export function getTopicsItemApi(topic_id, data) {
  return request({
    method: "GET",
    url: `topics/${topic_id}/items`,
    params: data
  });
}

// 获取圈子页帖子详情列表
export function getTopicsItemMoreApi(topic_id) {
  return request({
    method: "GET",
    url: `items/${topic_id}`
  });
}

// 获取发现页帖子列表
export function getDiscoveryApi(data) {
  return request({
    method: "GET",
    url: `discovery/items`,
    params: data
  });
}

// 获取帖子详情信息
export function getTopicsInfoApi(id) {
  return request({
    method: "GET",
    url: `items/${id}`
  });
}

// 帖子点赞
export function likesPostsApi(item_id) {
  return request({
    method: "POST",
    url: `items/${item_id}/likes`
  });
}

// 帖子取消点赞
export function cancelLikesPostsApi(item_id) {
  return request({
    method: "DELETE",
    url: `items/${item_id}/likes`
  });
}

// 关注接口
export function isFollowApi(user_id) {
  return request({
    method: "POST",
    url: `users/${user_id}/follows`
  });
}

// 取消关注接口
export function offFollowApi(user_id) {
  return request({
    method: "DELETE",
    url: `users/${user_id}/follows`
  });
}
